import { createI18n } from 'vue-i18n'
import zh from '@/locales/zh.json'
import en from '@/locales/en.json'

const detectBrowserLocale = () => {
  if (typeof navigator === 'undefined') {
    return 'zh'
  }

  return navigator.language.toLowerCase().startsWith('en') ? 'en' : 'zh'
}

const savedLocale = localStorage.getItem('locale')
const initialLocale = savedLocale || detectBrowserLocale()

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: 'zh',
  messages: {
    zh,
    en
  },
  escapeParameter: true
})

export default i18n
